import { createContext, useContext } from "react";

import type { IClientMinimal } from "@/api";

/**
 * Read surface for the composer's staged client selection (Unit 5's
 * `ComposerClientSelector` writes it). Lets siblings inside the composer
 * — the attachment pill row's cross-client warning — compare against the
 * staged scope on brand-new threads, where no conversation (and thus no
 * `useConversationClient` data) exists yet. The adapter side-channel
 * (`setNextClientId`) stays the single source of truth `initialize()`
 * consumes; this context only mirrors it for display.
 */
export interface ComposerClientScope {
    stagedClient: IClientMinimal | null;
    setStagedClient: (client: IClientMinimal | null) => void;
}

export const ComposerClientScopeContext = createContext<ComposerClientScope>({
    stagedClient: null,
    setStagedClient: () => undefined,
});

export const useComposerClientScope = (): ComposerClientScope =>
    useContext(ComposerClientScopeContext);
